<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-sm="10" offset-sm="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                <div class="padding">

                    <div class="text-center">

                        <header-challenges title="Twoje osiągnięcia"></header-challenges>

                        <p class="pd-0 mt-0">Twoje osiągnięcia miesięczne</p>
                        <div class="list">
                            <div class="item" v-for="item in $store.getters.getSummaryMonths">
                                <item-progress
                                        :title="item.month"
                                        :value="item.realizationPercent"
                                        suffix="%"
                                        :bar="true"
                                        label="plan miesięczny"
                                        :remaining="item.stillLeft"
                                        size="large"
                                        color="#ff0000">
                                </item-progress>
                            </div>
                            <div v-if="$store.getters.getSummaryMonths.length === 0">Brak danych</div>
                        </div>
                        <hr class="mt-40"/>
                    </div>

                    <div class="text-center">
                        <p class="pd-0">Twoje osiągnięcia kwartalne</p>
                        <div class="list">
                            <div class="item" v-for="item in $store.getters.getSummaryQuarters">
                                <item-progress
                                        :title="'Kwartał ' + item.quarter"
                                        :value="item.realizationPercent"
                                        suffix="%"
                                        :bar="true"
                                        label="planu kwartalnego"
                                        :remaining="item.stillLeft"
                                        size="large"
                                        color="#ff0000">
                                </item-progress>
                            </div>
                            <div v-if="$store.getters.getSummaryQuarters.length === 0">Brak danych</div>
                        </div>
                        <hr class="mt-40"/>
                    </div>

                    <div class="text-center">
                        <p class="pd-0">Twoje bonusy miesięczne</p>
                        <div class="list">
                            <div class="item" v-for="item in $store.getters.getSummaryMonthlyBonus">
                                <item-progress
                                        :title="item.month"
                                        :value="item.bonus"
                                        suffix=""
                                        :bar="false"
                                        label="złotych punktów"
                                        remaining=""
                                        size="large"
                                        color="#ff0000">
                                </item-progress>
                            </div>
                            <div v-if="$store.getters.getSummaryMonthlyBonus.length === 0">Brak danych</div>
                        </div>
                        <hr class="mt-40"/>
                    </div>

                    <div class="text-center">
                        <p class="pd-0">Twoje bonusy kwartalne</p>
                        <div class="list">
                            <div class="item" v-for="item in $store.getters.getSummaryQuarterlyBonus">
                                <item-progress
                                        :title="'Kwartał ' + item.quarter"
                                        :value="item.bonus"
                                        suffix=""
                                        :bar="false"
                                        label="złotych punktów"
                                        remaining=""
                                        size="large"
                                        color="#ff0000">
                                </item-progress>
                            </div>
                            <div v-if="$store.getters.getSummaryQuarterlyBonus.length === 0">Brak danych</div>
                        </div>
                        <hr class="mt-40"/>
                    </div>

                    <div class="text-center mb-20">
                        <p class="pd-0">Łączna ilość zdobytych bonusów</p>
                        <item-progress
                                :title="false"
                                :value="$store.getters.getSummaryTotalBonus"
                                suffix=""
                                :bar="false"
                                label="złotych punktów"
                                remaining=""
                                size="large"
                                color="#ff0000">
                        </item-progress>
                    </div>

                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    import HeaderChallenges from "./../Header.vue";
    import ItemProgress from "../../../items/ItemProgress.vue";

    export default {
        name: 'SummaryTab',
        components: { HeaderChallenges, ItemProgress },
    }
</script>